import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/')({
  loader: async () => redirect({ to: '/', replace: true }),
});
